import { Tag, Tooltip } from 'antd';

import { formatDisplayDateTime } from '../../utils/dateDisplay';
import { isPendingIntake, isDemoItem } from '../../services/records';
import IntakePendingTag from './IntakePendingTag';
import DemoTag from './DemoTag';

/**
 * What a RECORD OF RECORD is doing right now, in one or two small tags:
 * corrected, locked, or temporarily open — and, first of all, whether it is an
 * intake submission still waiting for review.
 *
 * These go where a reader is already looking — the read view, the pane head,
 * the row — because the one way to make a locked record confusing is to let
 * someone discover it by being refused. A corrected record says so loudest:
 * it is still true as history and no longer true as fact, and nothing else
 * on the surface makes that distinction.
 */
export default function RecordStateTags({ item, lockState, onOpenCorrection }) {
	const superseded = !!item?.supersededBy;
	const pending = isPendingIntake(item);
	if (!superseded && !pending && !isDemoItem(item) && !lockState?.locked && !lockState?.unlocked) return null;

	return (<>
		<IntakePendingTag item={item} />
		<DemoTag item={item} />
		{superseded ? (
			<Tooltip title='A later entry restates this one. This record is kept as it was written.'>
				<Tag
					color='orange'
					onClick={onOpenCorrection}
					style={onOpenCorrection ? { cursor: 'pointer' } : undefined}
				>
					Corrected
				</Tag>
			</Tooltip>
		) : null}
		{lockState?.locked ? (
			<Tooltip title={`${ lockState.reason || 'This record is closed to edits.' } A manager can unlock it, or you can add a correction.`}>
				<Tag>Locked</Tag>
			</Tooltip>
		) : null}
		{lockState?.unlocked ? (
			<Tooltip title={`Unlocked until ${ formatDisplayDateTime(lockState.until) }. The next save closes it again.`}>
				<Tag color='gold'>Unlocked</Tag>
			</Tooltip>
		) : null}
	</>);
}
